import { Injectable } from '@angular/core';
import { AppSettings } from '../enums/app-settings.enum';
import { UtilitiesService } from '../utilities/utilities.service';

@Injectable({
  providedIn: 'root',
})
export class AdobeAnalyticsService {
  private currency = AppSettings.LOCAL_CURRENTCY;
  constructor(
    private UTS: UtilitiesService
  ) { }
  page(AT: string) {
    const language =
      this.UTS.getLocaleLanguage() &&
        this.UTS.getLocaleLanguage().toLowerCase() == 'en'
        ? ''
        : '-AR';
    const payload = {
      event: 'navigation',
      user_env: this.UTS.getENV(),
      eventCategory: 'navigation' + language,
      eventAction: 'add-ons-sections',
      eventLabel: 'add-ons',
      Link: AT,
    };
    this.pushDateOnAdobeAnalytics(payload);
  }

  category(AT: string, SC: string) {
    const language =
      this.UTS.getLocaleLanguage() &&
        this.UTS.getLocaleLanguage().toLowerCase() == 'en'
        ? ''
        : '-AR';
    const payload = {
      event: 'navigation',
      user_env: this.UTS.getENV(),
      eventCategory: 'navigation' + language,
      eventAction: 'add-ons-sections',
      eventLabel: AT && AT.includes(' ') ? AT.split(' ').join('_') : AT,
      Link: SC,
    };
    this.pushDateOnAdobeAnalytics(payload);
  }

  filter(F: string) {
    const language =
      this.UTS.getLocaleLanguage() &&
        this.UTS.getLocaleLanguage().toLowerCase() == 'en'
        ? ''
        : '-AR';
    const payload = {
      event: 'filter',
      user_env: this.UTS.getENV(),
      eventCategory: 'filter' + language,
      eventAction: 'click',
      eventLabel: F && F.includes(' ') ? F.split(' ').join('_') : F,
    };
    this.pushDateOnAdobeAnalytics(payload);
  }

  productImpressions(impressions: any) {
    const payload = {
      event: 'productImpressions',
      user_env: this.UTS.getENV(),
      ecommerce: {
        currencyCode: this.currency,
        impressions: impressions,
      },
    };
    this.pushDateOnAdobeAnalytics(payload);
  }

  productClick(
    AT: string,
    SC: string,
    PN: string,
    PID: string,
    PP: string,
    I: number,
    B: string
  ) {
    const payload = {
      event: 'productClick',
      user_env: this.UTS.getENV(),
      ecommerce: {
        click: {
          actionField: {
            list: `${AT}_Add_ons`, //String - Product List Name
          },
          products: [
            {
              name: PN, //String - Product Name
              id: PID, //String - Product ID
              price: PP, //String - Product Price
              brand: B, //String - Product Brand
              category: AT, //String - Product Category
              dimension25: SC, //String - Category  (if available) Data or Combo or Roaming
              position: I, //Number - Position in the list
            },
          ],
        },
      },
    };

    this.pushDateOnAdobeAnalytics(payload);
  }

  productDetailImpression(
    AT: string,
    SC: string,
    PN: string,
    PID: string,
    PP: string,
    B: string
  ) {
    const payload = {
      event: 'productDetailImpression',
      user_env: this.UTS.getENV(),
      ecommerce: {
        detail: {
          //Detail object
          actionField: {
            list: `${AT}_Add_ons`, //String - Product List Name
          }, // 'detail' actions have an optional list property. Pass from which list user have arrived to the detail page
          products: [
            {
              name: PN, //String - Product Name
              id: PID, //String - Product ID
              price: PP, //String - Product Price
              brand: B, //String - Product Brand
              category: AT, //String - Product Category
              dimension25: SC, //String - Category  (if available) Data or Combo or Roaming
              // position: I, //Number - Position in the list
            },
          ],
        },
      },
    };
    this.pushDateOnAdobeAnalytics(payload);
  }

  addToCart(
    AT: string,
    SC: string,
    PN: string,
    PID: string,
    PP: string,
    I: number,
    B: string
  ) {
    const payload = {
      event: 'addToCart',
      user_env: this.UTS.getENV(),
      ecommerce: {
        currencyCode: this.currency,
        add: {
          //Detail object
          actionField: {
            list: `${AT}_Add_ons`, //String - Product List Name
          }, // 'detail' actions have an optional list property. Pass from which list user have arrived to the detail page
          products: [
            {
              name: PN, //String - Product Name
              id: PID, //String - Product ID
              price: PP, //String - Product Price
              brand: B, //String - Product Brand
              category: AT, //String - Product Category
              dimension25: SC, //String - Category  (if available) Data or Combo or Roaming
              quantity: I, //Number - Position in the list
            },
          ],
        },
      },
    };

    this.pushDateOnAdobeAnalytics(payload);
  }

  purchase(
    AT: string,
    SC: string,
    PN: string,
    PID: string,
    PP: string,
    I: number,
    B: string,
    TID: string,
    R: string,
    T?: string,
    S?: string,
    C?: string
  ) {
    const payload = {
      event: 'purchase',
      user_env: this.UTS.getENV(),
      actionField: {
        id: TID, // Transaction ID. Required for purchases and refunds.
        affiliation: 'Online Store',
        revenue: R, // Total transaction value (incl. tax and shipping)
        tax: T ? T : '',
        shipping: S ? S : '',
        coupon: C ? C : '',
      },
      ecommerce: {
        currencyCode: this.currency,
        purchase: {
          //Detail object
          actionField: {
            list: `${AT}_Add_ons`, //String - Product List Name
          }, // 'detail' actions have an optional list property. Pass from which list user have arrived to the detail page
          products: [
            {
              name: PN, //String - Product Name
              id: PID, //String - Product ID
              price: PP, //String - Product Price
              brand: B, //String - Product Brand
              category: AT, //String - Product Category
              dimension25: SC, //String - Category  (if available) Data or Combo or Roaming
              quantity: I, //Number - Position in the list
            },
          ],
        },
      },
    };
    this.pushDateOnAdobeAnalytics(payload);
  }

  OTPVerification(EA: string, EL: string) {
    const language =
      this.UTS.getLocaleLanguage() &&
        this.UTS.getLocaleLanguage().toLowerCase() == 'en'
        ? ''
        : '-AR';
    const payload = {
      event: 'OTPVerification',
      eventCategory: 'OTPVerification' + language,
      eventLabel: EA, //:  ‘submit or error-name of error’,
      eventAction: EL.split(' ').join('_'),
      user_env: this.UTS.getENV(),
    };
    this.pushDateOnAdobeAnalytics(payload);
  }

  private pushDateOnAdobeAnalytics(P: any) {
    try {
      if (window.adobeDataLayer) {
        window.adobeDataLayer.push(P);
      }
    } catch (e) {
      this.UTS.error(e)
    }
  }
}
